import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button/index.js';
import { MaterialCheckbox } from '../../material/MaterialCheckbox.js';
import { i18n } from '../../i18n/translate.js';

var FormSaveButtons = /*#__PURE__*/function (_React$Component) {
  function FormSaveButtons(props) {
    _classCallCheck(this, FormSaveButtons);

    return _callSuper(this, FormSaveButtons, [props]);
  }

  _inherits(FormSaveButtons, _React$Component);

  return _createClass(FormSaveButtons, [{
    key: "buildCheckbox",
    value: function buildCheckbox(show, btn_class, text, disabled) {
      if (show) {
        return /*#__PURE__*/React.createElement(MaterialCheckbox, {
          "data-object-type": this.props.dataType,
          "data-object-id": this.props.dataId,
          "data-object-action": "form-save-add-another",
          className: "".concat(btn_class, " left-checkbox"),
          disabled: disabled,
          inline: true,
          name: "saveAndAddCheckbox"
        }, text);
      }
    }
  }, {
    key: "buildButton",
    value: function buildButton(_ref) {
      var func = _ref.func,
          id = _ref.id,
          className = _ref.className,
          style = _ref.style,
          text = _ref.text,
          iconType = _ref.iconType,
          disabled = _ref.disabled,
          showLoader = _ref.showLoader,
          dataAction = _ref.dataAction;

      if (showLoader) {
        style += ' btn-icon-text';
        iconType = 'spinner';
      }

      if (func) {
        return /*#__PURE__*/React.createElement(Button, {
          branded: this.props.branded,
          className: className,
          "data-action": dataAction,
          "data-object-type": this.props.dataType,
          "data-object-id": this.props.dataId,
          "data-object-action": "form-".concat(id),
          disabled: this.props.isDisabled || disabled,
          icon: iconType,
          id: "".concat(this.props.className, "-").concat(id),
          label: text,
          onClick: func,
          style: style,
          renderAsLegacy: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          buttonBaseClass = _this$props.buttonBaseClass,
          buttonStyle = _this$props.buttonStyle,
          buttonStyleDelete = _this$props.buttonStyleDelete,
          buttonStyleSecondary = _this$props.buttonStyleSecondary,
          cancel = _this$props.cancel,
          cancelButtonText = _this$props.cancelButtonText,
          cancelIconType = _this$props.cancelIconType,
          className = _this$props.className,
          deleteButtonText = _this$props.deleteButtonText,
          deleteIconType = _this$props.deleteIconType,
          isDisabled = _this$props.isDisabled,
          leftButtonStyle = _this$props.leftButtonStyle,
          leftButtonText = _this$props.leftButtonText,
          leftButtonClick = _this$props.leftButtonClick,
          leftButtonIconType = _this$props.leftButtonIconType,
          noPaddingButtons = _this$props.noPaddingButtons,
          save = _this$props.save,
          saveIconType = _this$props.saveIconType,
          saveAndAdd = _this$props.saveAndAdd,
          saveAndAddButtonText = _this$props.saveAndAddButtonText,
          saveAndAddCheckbox = _this$props.saveAndAddCheckbox,
          saveAndAddCheckboxClass = _this$props.saveAndAddCheckboxClass,
          saveAndAddCheckboxText = _this$props.saveAndAddCheckboxText,
          saveAndAddIconType = _this$props.saveAndAddIconType,
          saveButtonAreaClassName = _this$props.saveButtonAreaClassName,
          saveButtonDisabled = _this$props.saveButtonDisabled,
          saveButtonText = _this$props.saveButtonText,
          saveButtonDataAction = _this$props.saveButtonDataAction;
      return /*#__PURE__*/React.createElement("div", {
        "data-action": "modal-footer",
        className: className
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      }, this.buildButton({
        func: leftButtonClick,
        id: 'left-button',
        className: buttonBaseClass,
        style: leftButtonStyle,
        text: leftButtonText,
        iconType: leftButtonIconType
      }), this.buildButton({
        func: this.props["delete"],
        id: 'delete',
        className: buttonBaseClass,
        style: buttonStyleDelete,
        text: deleteButtonText || i18n.t('Delete'),
        iconType: deleteIconType
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-9 ".concat(saveButtonAreaClassName, " ").concat(noPaddingButtons ? 'no-padding' : '')
      }, this.buildCheckbox(saveAndAddCheckbox, saveAndAddCheckboxClass, saveAndAddCheckboxText || i18n.t('Save and Add Another')), this.buildButton({
        func: cancel,
        id: 'cancel',
        className: buttonBaseClass,
        style: buttonStyleSecondary,
        text: cancelButtonText || i18n.t('Cancel'),
        iconType: cancelIconType
      }), this.buildButton({
        func: save,
        id: 'save',
        className: buttonBaseClass,
        style: buttonStyle,
        text: saveButtonText || i18n.t('Save'),
        iconType: saveIconType,
        disabled: saveButtonDisabled,
        showLoader: isDisabled,
        dataAction: saveButtonDataAction
      }), this.buildButton({
        func: saveAndAdd,
        id: 'save-and-add',
        className: buttonBaseClass,
        style: buttonStyle,
        text: saveAndAddButtonText || i18n.t('Save and Add Another'),
        iconType: saveAndAddIconType
      })));
    }
  }]);
}(React.Component);

_defineProperty(FormSaveButtons, "propTypes", {
  branded: PropTypes.bool,
  cancel: PropTypes.func,
  cancelButtonText: PropTypes.string,
  cancelIconType: PropTypes.string,
  className: PropTypes.string,
  buttonBaseClass: PropTypes.string,
  buttonStyle: PropTypes.string,
  buttonStyleSecondary: PropTypes.string,
  buttonStyleDelete: PropTypes.string,
  dataId: PropTypes.string,
  dataType: PropTypes.string,
  "delete": PropTypes.func,
  deleteButtonText: PropTypes.string,
  deleteIconType: PropTypes.string,
  isDisabled: PropTypes.bool,
  leftButtonStyle: PropTypes.string,
  leftButtonText: PropTypes.string,
  leftButtonClick: PropTypes.func,
  leftButtonIconType: PropTypes.string,
  noPaddingButtons: PropTypes.bool,
  save: PropTypes.func,
  saveAndAdd: PropTypes.func,
  saveAndAddButtonText: PropTypes.string,
  saveAndAddCheckbox: PropTypes.bool,
  saveAndAddCheckboxClass: PropTypes.string,
  saveAndAddCheckboxText: PropTypes.string,
  saveAndAddIconType: PropTypes.string,
  saveButtonAreaClassName: PropTypes.string,
  saveButtonDisabled: PropTypes.bool,
  saveButtonText: PropTypes.string,
  saveButtonDataAction: PropTypes.string,
  saveIconType: PropTypes.string
});

_defineProperty(FormSaveButtons, "defaultProps", {
  branded: false,
  isDisabled: false,
  saveButtonDisabled: false,
  buttonBaseClass: 'btn',
  buttonStyle: 'primary',
  buttonStyleSecondary: 'secondary',
  buttonStyleDelete: 'primary',
  className: '',
  saveButtonAreaClassName: ''
});

FormSaveButtons.displayName = "FormSaveButtons";
export { FormSaveButtons };